import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { CardStack } from "@shared/models/card-stack"
import type { Planbook } from "@shared/models/planbook"
import { handleError } from "cc-frontend/error-handling"
import { PLANBOOK_DELETE_TEMPLATE } from "cc-frontend/lib/actions/planbook/PLANBOOK_DELETE_TEMPLATE"
import type Dialog from "cc-frontend/services/dialog"
import type Dispatcher from "cc-frontend/services/dispatcher"

interface Signature {
  Args: {
    cardStack: CardStack
    planbook: Planbook
    hideTemplateMagic: boolean
    hideDeleteButton: boolean
  }
}

export default class LessonTemplate extends Component<Signature> {
  @service declare dispatcher: Dispatcher
  @service declare dialog: Dialog

  @action
  deleteTemplate() {
    this.dialog
      .blank("dialogs/confirm-delete-lesson-template", {
        className: "dialog--create-annotation",
      })
      .then(() => {
        this.dispatcher.dispatchAction(PLANBOOK_DELETE_TEMPLATE, {
          cardStackId: this.args.cardStack.id,
          planbookId: this.args.planbook.id,
        })
      })
      .catch((error) => {
        if (error instanceof Error) handleError(error)
      })
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "School::Edit::LessonTemplate": typeof LessonTemplate
  }
}
